module.exports = __webpack_public_path__ + "static/media/Thumbs.8842a270.db";